

































import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { GuidHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/GuidHelper';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import PGRowWorkScopeValue from '@/components/common/property/PGRowWorkScopeValue.vue';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';

@Component({
  components: {
    PGRowWorkScopeValue
  }
})
export default class AddProduct extends Vue {
  private product: Product = null;

  constructor() {
    super();
    this.product = new Product();
    this.product.designId = GuidHelper.getGuid();
    this.product.persistenceStatus = EnumPersistenceStatus.Create;
  }

  cancel() {
    (this.$refs.product as any).resetFields();
    this.$emit('closeDialog', null);
  }

  confirm() {
    (this.$refs.product as any).validate((valid: any) => {
      if (valid) {
        this.product.workScope = this.getWorkScopes().find((item: WorkScope) => item.id === this.product.workScope_ID) as WorkScope;
        this.$emit('closeDialog', this.product);
      } else {
        return false;
      }
    });
  }

  beforeClose() {
    this.$confirm('关闭后未保存的信息将会丢失，确认要关闭么？')
      .then(_ => {
        this.cancel();
      })
      .catch(_ => {
        // do nothing
      });
  }

  getWorkScopes() {
    return this.$store.state.ModuleMD.workScopes;
  }

  get labelWidth() {
    return '100px';
  }
}

